/**
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
'use strict';

module.exports = {
    BaseStore: require('./BaseStore'),
    createStore: require('./createStore')
};



//////////////////
// WEBPACK FOOTER
// ./~/fluxible/addons/index.js
// module id = 143
// module chunks = 20 22 23 25